import { render, staticRenderFns } from "./product_detail.vue?vue&type=template&id=bf8df4e2&scoped=true"
import script from "./product_detail.vue?vue&type=script&lang=js"
export * from "./product_detail.vue?vue&type=script&lang=js"
import style0 from "./product_detail.vue?vue&type=style&index=0&id=bf8df4e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8df4e2",
  null
  
)

export default component.exports